import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray,FormControl } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//validators
import { dropDownValidator }                from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator }                from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

import {VendPackageDropdownComponent} from '../../components/DomainData/VendPackageDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-vendpackagelineitem-edit',
  templateUrl: './VendPackageLineItemEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => VendPackageLineItemEditComponent)}]
})
export class VendPackageLineItemEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    vendPackageLineItemForm: FormGroup;

    @Input() public lineItem: ent.VendPackageLineItem = new ent.VendPackageLineItem();

    @Input() public requireVendPackage: boolean;
    @Input() public requireVendPrice: boolean;
    @Input() public requireCommissionPercent: boolean;

    @ViewChild(VendPackageDropdownComponent) public vendPackageDropdown: VendPackageDropdownComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'vendPackage' : '',
          'hidVendPackage' : '',
          'vendPrice' : '',
          'commissionPercent' : ''
        };
        
        this.vendPackageLineItemForm = fb.group(group);

    }


    ngOnInit(): void {
        

        if(this.requireVendPackage) {
            this.vendPackageLineItemForm.controls['vendPackage'].setValidators(dropDownValidator);
            this.vendPackageLineItemForm.controls['hidVendPackage'].setValidators(hiddenDropDownValueValidator);
        }
        if(this.requireVendPrice) {
            this.vendPackageLineItemForm.controls['vendPrice'].setValidators(Validators.required);
        }
        if(this.requireCommissionPercent) {
            this.vendPackageLineItemForm.controls['commissionPercent'].setValidators(Validators.required);
        }
    }

    vendPackageSelected(){
        var val = true;
        var form = this.vendPackageLineItemForm;
        if (form.controls.vendPackage.errors && form.controls.hidVendPackage.errors){
            if (form.controls.vendPackage.errors.invalid && form.controls.hidVendPackage.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    vendPackageChange(event: any){
        this.lineItem.VendPackageID = event;
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.lineItem.VendPackageID = this.vendPackageDropdown.value;
       
        this.onOK.emit();
        
        this.displayDialog = false;

    }


}